<div class="t-popup popup-patientDetails">
  <div class="t-popup-close"></div>

  <div class="t-popup-frame" style="width: 65em; max-width: fit-content">
    <div class="t-popup-body" [formGroup]="concentForm">
      <button
        class="t-btn-popup-close"
        matTooltip="Close Popup"
        aria-label="close popup"
        (click)="close(false)"
      ></button>
      <div class="m-box w100" style="direction: rtl; font-size: 20px">
        <h2>הסכמה מדעת</h2>
        <div class="r-concent l-end">
          <div style="border: 1px solid black" *ngIf="waitingForSignatures">
            ממתין לקבלת טופס חתום
          </div>
          <div style="border: 1px solid black" *ngIf="errorInSignature">
            חסרות חתימות יש לשלוח את הטופס שוב
          </div>
          <span
            class="l-header-panel header-menu-link icon-link concent-link"
            (click)="handleSaveAndShowLink()"
            [ngClass]="{ 'disabled-icon': isIudTypeMissing }"
            [style.cursor]="
              isIudTypeMissing ? 'not-allowed' : lockedConsent ? 'default' : 'pointer'
            "
            [style.opacity]="isIudTypeMissing ? '0.4' : '1'"
            [style.pointer-events]="isIudTypeMissing ? 'none' : 'auto'"
            style="margin-left: 0.5em; margin-right: 1em"
            aria-label="Link"
            [matTooltip]="linkTooltipMsg()"
          >
          </span>
          <span
            (click)="printConsent()"
            class="header-menu-link icon-print"
            [ngClass]="{ 'disabled-icon': isIudTypeMissing }"
            [style.cursor]="isIudTypeMissing ? 'not-allowed' : 'pointer'"
            [style.opacity]="isIudTypeMissing ? '0.4' : '1'"
            [style.pointer-events]="isIudTypeMissing ? 'none' : 'auto'"
            aria-label="Print"
            matTooltip="Print"
            style="
              margin-left: 0.5em;
              margin-right: 1em;
              filter: invert(39%) sepia(8%) saturate(4116%) hue-rotate(143deg) brightness(60%)
                contrast(78%);
            "
          ></span>
        </div>

        <span>
          <h2>{{ getConsentTitle() }}</h2>
        </span>

        <div style="direction: rtl; margin-bottom: 1em">
          <span>
            <ng-container
              *ngIf="concentForm.get('GynConsentType').value === 'Hysterosalpingo Sonography'"
            >
              <div class="r-concent">
                דימות הרחם והחצוצרות נעשה לצורך בדיקת תקינות חלל הרחם ועבירות החצוצרות. הבדיקה
                מבוצעת במסגרת בירור אי פריון, או לצורך בירור ממצאים בחצוצרות או בחלל הרחם כגון נישה
                בצלקת ניתוחית, פוליפים, שרירנים, הידבקויות וכו'.
              </div>
            </ng-container>
            <ng-container *ngIf="concentForm.get('GynConsentType').value === 'Insertion of IUD'">
              <div class="r-concent"><strong>מהות הבעיה הרפואית:</strong> מניעת היריון.</div>

              <div class="r-concent">
                התקן תוך רחמי הוא אביזר המוחדר לרחם לצורך מניעת היריון. ישנם 2 סוגי התקנים – התקן
                נחושת והתקן הורמונלי.
              </div>

              <div class="r-concent">
                יעילות ההתקן למניעת היריון גבוהה ועומדת על מעל ל- 99%, כלומר צפוי פחות מהיריון אחד
                אצל כל מאה נשים שמשתמשות בהתקן במשך שנה אחת.
              </div>

              <div class="r-concent">
                לצורך השגת יעילות מרבית, יש להחליף את ההתקן כל 3-10 שנים, על פי סוג ההתקן.
              </div>

              <div class="r-concent">
                לפני החדרת ההתקן עליך למסור לרופא פרטים הקשורים בבריאותך, ובעיקר אם סבלת או הנך
                סובלת ממחלות שעלולות להוות הוריות נגד לשימוש בהתקן כמו: דימום נרתיקי לא מאובחן, דלקת
                פעילה ברחם או באגן, מום רחמי ידוע, הפרעות קרישה.
              </div>

              <div class="r-concent">
                כמו כן, יש לדווח לרופא על תאריך הוסת האחרון ולשלול בפניו כל אפשרות של היריון.
              </div>

              <div class="r-concent">
                לפני החדרת ההתקן תבוצע בדיקה גינקולוגית או אולטרסאונד כדי לקבוע את גודל ומיקום הרחם.
                הרופא יחדיר מפשק (ספקולום) לנרתיק כדי לאפשר לו גישה לפתח צוואר הרחם, ויחדיר דרכו את
                ההתקן לחלל הרחם.
              </div>
            </ng-container>
          </span>
        </div>

        <div>
          <span><strong>שם הנבדקת</strong></span>
        </div>
        <div style="display: flex; margin-bottom: 2em">
          <div
            class="login-form-row"
            style="background-color: #e4eded; margin: 5px; border-radius: 0.75em"
          >
            <input
              formControlName="Last"
              type="text"
              style="width: auto"
              class="w50 l-textarea t-field--limitRad h100"
              placeholder="שם משפחה"
            />
          </div>
          <div
            class="login-form-row"
            style="background-color: #e4eded; margin: 5px; border-radius: 0.75em"
          >
            <input
              formControlName="First"
              type="text"
              style="width: auto"
              class="w50 l-textarea t-field--limitRad h100"
              placeholder="שם פרטי"
            />
          </div>
          <div
            class="login-form-row"
            style="background-color: #e4eded; margin: 5px; border-radius: 0.75em"
          >
            <input
              formControlName="ID"
              type="text"
              style="width: auto"
              class="w50 l-textarea t-field--limitRad h100"
              placeholder="ת.ז"
            />
          </div>
          <div
            class="login-form-row"
            style="background-color: #e4eded; margin: 5px; border-radius: 0.75em"
          >
            <input
              formControlName="Phone"
              type="text"
              style="width: auto"
              class="w50 l-textarea t-field--limitRad h100"
              placeholder="טלפון"
            />
          </div>
        </div>

        <div style="margin: 1em 0">
          <span style="display: flex; align-items: center">
            <strong style="margin-left: 1em; white-space: nowrap">
              אני מצהירה ומאשרת בזאת שקיבלתי הסבר מפורט ובעל פה מ
            </strong>
            <input
              formControlName="refferalDoc"
              type="text"
              class="w50 l-textarea t-field--limitRad h100"
              style="border-radius: 0.75em; margin-right: 1em; width: auto"
              placeholder="שם הרופא"
          /></span>
        </div>

        <div style="display: grid">
          <input
            formControlName="CreationTime"
            type="datetime-local"
            formtarget="yyyy-MM-ddThh:mm"
            class="w50 l-textarea t-field--limitRad h100"
            style="margin-left: 5px; border-radius: 0.75em; place-self: center"
            placeholder="תאריך ושעה"
          />
        </div>

        <div style="display: grid; place-self: center">
          <span>חתימת הנבדקת\אפוטרופוס</span>
          <canvas
            id="canvas"
            #canvas
            [style.border]="'1px solid black'"
            [ngClass]="type == 'canvas' ? 'can-shadow' : ''"
            width="500"
            height="200"
            [ngClass]="{ 'disabled-canvas': lockedConsent }"
            (click)="setCanvas('canvas')"
          ></canvas>
          <button
            [disabled]="lockedConsent"
            style="position: relative; top: -2em; width: fit-content"
            (click)="clear('patSign')"
          >
            <ng-container>
              <img
                src="../../assets/icons/login/reset.png"
                style="height: 1.5em; width: 1.5em"
                matTooltip="Clear"
              />
            </ng-container>
          </button>
        </div>

        <hr class="r-concent" />
        <ng-container *ngIf="concentForm.get('GynConsentType').value === 'Insertion of IUD'">
          <div class="r-concent">
            אני מצהירה ומאשרת בזאת שקיבלתי הסבר מפורט, על החדרת התקן תוך רחמי (להלן "הפעולה
            העיקרית"), הבנתי אותו וניתנה לי האפשרות לשאול שאלות ולדון על הפעולה, החלופות הטיפוליות,
            הסיכונים והתועלת.
          </div>

          <div class="r-concent">
            כמו כן, הוסברו לי החלופות הטיפוליות הקיימות לטיפול במצבי, כמו גלולות למניעת היריון או
            אמצעי מניעה חוצצים.
          </div>

          <div class="r-concent">
            אני מצהירה ומאשרת בזאת כי הוסברו לי תופעות הלוואי לאחר הפעולה העיקרית והן:
          </div>

          <div class="r-concent">
            <strong>תופעות לוואי אופייניות להתקן נחושת:</strong>
          </div>

          <div class="r-concent">
            דמם ווסתי מוגבר ו/או מתמשך מעבר לרגיל, ולעיתים הגברה של כאבי הווסת. מצב זה הפיך עם הוצאת
            ההתקן.
          </div>

          <div class="r-concent">
            <strong>תופעות לוואי אופייניות להתקן הורמונלי:</strong>
          </div>

          <div class="r-concent">
            לאחר ההתקנה יש דימומים לסירוגין, שיכולים להמשך ממספר ימים ועד מספר חודשים. ירידה
            משמעותית בכמות הדמם הווסתי ולעיתים הפסקה מוחלטת של הדמם הווסתי. מצב זה הפיך עם הוצאת
            ההתקן.
          </div>

          <div class="r-concent">הופעת ציסטות שפירות בשחלות, שנעלמות עם הוצאת ההתקן.</div>

          <div class="r-concent">
            תופעות לוואי פחות שכיחות: אקנה, תחושת נפיחות וגודש עקב צבירת נוזלים, כאבי ראש, אובדן
            שיער ושינויים במצב הרוח.
          </div>

          <div class="r-concent">
            החדרת ההתקן נעשית בד"כ ללא אלחוש, כרוכה באי נוחות, ולעיתים כתופעת לוואי בכאב שיכול להמשך
            גם מספר ימים אחרי ההתקנה.
          </div>

          <div class="r-concent">
            הוסבר לי ואני מבינה שקיימת אפשרות שתוך מהלך הפעולה הרפואית של החדרת התקן תוך רחמי יתברר
            שיש צורך לבצע פעולות טיפוליות נוספות לשם ביצוע הפעולה כגון: ביצוע אלחוש מקומי ו/או הרחבת
            צוואר הרחם.
          </div>

          <div class="r-concent">
            כמו כן, הוסברו לי הסיכונים והסיבוכים האפשריים (ללא תלות בסוג ההתקן), לרבות:
          </div>

          <div class="r-concent">
            • שכיחות יתר של זיהומים באיברי המין בעיקר בחודש הראשון לאחר ההתקנה, שללא טיפול עלולים
            לגרום לבעיות פוריות בעתיד.
          </div>

          <div class="r-concent">• פליטת ההתקן מבלי לחוש/לדעת שההתקן נפלט.</div>

          <div class="r-concent">
            • כניסה להיריון בנוכחות ההתקן אינה שכיחה, אבל היריון כזה עלול להסתיים בהפלה מלווה בזיהום
            או בהיריון חוץ רחמי.
          </div>

          <div class="r-concent">
            • חוסר אפשרות לשלוף את ההתקן באמצעות החוט המשתלשל ממנו, עלול לחייב שימוש באמצעים נוספים
            עד כדי צורך בשליפתו בהרדמה.
          </div>

          <div class="r-concent">
            • חדירת ההתקן לדופן הרחם או לחלל הבטן. במקרים אלה עלול להיווצר צורך בהתערבות כירורגית.
            סיבוך זה הוא נדיר.
          </div>

          <div class="r-concent">
            במקרה בו הטיפול נעשה באלחוש מקומי/אזורי/חסימה עצבית, על ידי הרופא המבצע את הפעולה,
            הסכמתי ניתנת בזאת גם לביצוע אלחוש זה, לאחר שהוסברו לי הסיכונים והסיבוכים של הרדמה מקומית
            לרבות תגובה אלרגית בדרגות שונות לחומרי ההרדמה.
          </div>

          <div class="r-concent">
            לאחר החדרת ההתקן התוך רחמי יש לפנות לרופא אם הופיעו אחד מהסימנים הבאים:
          </div>

          <div class="r-concent">• דימום חריג בעוצמתו או בעיתויו.</div>

          <div class="r-concent">• כאבי בטן תחתונה, במיוחד אם מלווים בחום.</div>

          <div class="r-concent">• הפרשה לדנית חריגה.</div>

          <div class="r-concent">• איחור של הוסת.</div>

          <div class="r-concent">אני מצהירה בזאת כי למיטב ידיעתי איני בהיריון.</div>

          <div class="r-concent">יש להקפיד על ביקורת תקופתית בהתאם להמלצת הרופא.</div>
          <hr class="r-concent" />

          <div class="r-concent">
            <strong [ngClass]="{ 'missing-label': isIudTypeMissing, 'label-transition': true }"
              >אני נותנת בזאת את הסכמתי להחדרת התקן מסוג
            </strong>
            <select
              formControlName="iudType"
              [ngClass]="{ 'missing-field': isIudTypeMissing, 'border-transition': true }"
              class="l-textarea t-field--limitRad h100"
              style="border-radius: 0.75em; width: 250px; display: inline-block; margin: 0 5px"
            >
              <option value="" disabled>בחר סוג התקן</option>
              <option value="התקן נחושת">התקן נחושת</option>
              <option value="התקן הורמונלי">התקן הורמונלי</option></select
            >.
          </div>
        </ng-container>
        <ng-container
          *ngIf="concentForm.get('GynConsentType').value === 'Hysterosalpingo Sonography'"
        >
          <div class="r-concent">
            בתחילת הבדיקה מוכנסת צינורית לצוואר הרחם. בשלב הראשון מזריקים דרך הצינורית מים
            פיזיולוגיים (סליין), תוך כדי הדגמה של חלל הרחם באמצעות אולטרה סאונד. בשלב השני מזריקים
            דרך הצינורית מים פיזיולוגיים מעורבבים בבועיות אויר, או קצף שנוצר מערבוב ג'ל (המכיל
            הידרוקסיאתיל צלולוז וגליצרול) עם מים מזוקקים, המכיל אף הוא בועיות אויר. בועיות האויר
            משמשות כחומר ניגוד, וניתן לעקוב באמצעות אולטרה סאונד אחרי התנועה שלהן לאורך החצוצרות,
            ואחרי הפיזור שלהן באגן. בהתאם לצורך הקליני ניתן לבצע את שני השלבים ברצף או להסתפק בביצוע
            שלב אחד.
          </div>
          <div class="r-concent">
            הבדיקה מתבצעת לאחר סיום הוסת (במחצית הראשונה של המחזור) וללא הרדמה.
          </div>
          <div class="r-concent">אין לקיים יחסי מין לא מוגנים מהווסת ועד הבדיקה.</div>
          <div class="r-concent">
            אם הוסת האחרונה היתה שונה מהרגיל יש לידע את הרופא לפני הבדיקה על מנת לשלול קיום הריון.
          </div>
          <div class="r-concent">
            השלב הראשון של הבדיקה מהווה חלופה להיסטרוסקופיה, והשלב השני מהווה חלופה לצילום רחם.
            במקרים חריגים של קושי טכני בביצוע הבדיקה ניתן לשקול ביצוע היסטרוסקופיה או צילום רחם
            בהתאם לצורך הקליני.
          </div>
          <div class="r-concent">
            <strong> אם ידועה רגישות יש לידע את הרופא. </strong>
          </div>
          <div class="r-concent">
            צורת ההרדמה המלווה פעולה זאת:
            <strong> ללא הרדמה </strong>
          </div>
        </ng-container>

        <div style="display: grid; margin-bottom: 1em">
          <input
            formControlName="CreationTime"
            type="datetime-local"
            formtarget="yyyy-MM-ddThh:mm"
            class="w50 l-textarea t-field--limitRad h100"
            style="margin-left: 5px; border-radius: 0.75em; place-self: center"
            placeholder="תאריך ושעה"
          />
        </div>

        <div
          [ngClass]="concentForm.get('approved').value == 'paitent' ? '' : 'hidden'"
          style="display: grid; place-self: center"
        >
          <span>חתימת הנבדקת\אפוטרופוס</span>
          <canvas
            id="canvasPat"
            #canvasPat
            [style.border]="'1px solid black'"
            [ngClass]="type == 'canvasPat' ? 'can-shadow' : ''"
            width="500"
            height="200"
            [ngClass]="{ 'disabled-canvas': lockedConsent }"
            (click)="setCanvas('canvasPat')"
          ></canvas>
          <button
            [disabled]="lockedConsent"
            style="position: relative; top: -2em; width: fit-content"
            (click)="clear('patSignApproved')"
          >
            <ng-container>
              <img
                src="../../assets/icons/login/reset.png"
                style="height: 1.5em; width: 1.5em"
                matTooltip="Clear"
              />
            </ng-container>
          </button>
        </div>

        <div class="r-concent">
          <span>אני מאשר כי הסברתי בעל פה</span>
          <div
            class="l-flex-c l-flex-w indicative-fieldset h100"
            style="justify-content: space-evenly"
          >
            <label class="t-label-top">
              <input
                type="radio"
                formControlName="approved"
                value="paitent"
                class="custom-check -sq"
              />
              <i class="customInput-display -sq" style="margin-left: 0.31em"></i>
              <span> לנבדקת </span>
            </label>
            <label class="t-label-top">
              <input
                type="radio"
                formControlName="approved"
                value="appotropus"
                class="custom-check -sq"
              />
              <i class="customInput-display -sq" style="margin-left: 0.31em"></i>
              <span> לאפוטרופוס </span>
            </label>
            <label class="t-label-top">
              <input
                type="checkbox"
                name="placenta_TEMP_name"
                class="custom-check -sq"
                formControlName="translated"
                [value]="1"
              />
              <i class="customInput-display"></i>
              <span> למתרגם של המטופלת </span>
            </label>
            <div *ngIf="concentForm.get('translated').value == 1">
              <div
                class="login-form-row"
                style="
                  background-color: #e4eded;
                  margin: 5px;
                  border-radius: 0.75em;
                  height: fit-content;
                "
              >
                <input
                  formControlName="transName"
                  class="l-textarea t-field--limitRad"
                  style="margin-left: 5px; border-radius: inherit"
                  placeholder="שם המתרגם/ת"
                />
              </div>
              <div
                class="login-form-row"
                style="
                  background-color: #e4eded;
                  margin: 5px;
                  border-radius: 0.75em;
                  height: fit-content;
                "
              >
                <input
                  formControlName="transRel"
                  class="l-textarea t-field--limitRad"
                  style="margin-left: 5px; border-radius: inherit"
                  placeholder="קשריו לנדבקת"
                />
              </div>
            </div>
          </div>
          <div>
            את כל האמור לעיל בפירוט הדרוש וכי הוא/היא חתם/ה על הסכמה בפני לאחר ששוכנעתי כי הבין/ה את
            הסבריי במלואם.
          </div>
          <div *ngIf="concentForm.get('approved').value == 'appotropus'">
            <div style="display: flex">
              <div
                class="login-form-row"
                style="
                  background-color: #e4eded;
                  margin: 5px;
                  border-radius: 0.75em;
                  height: fit-content;
                "
              >
                <input
                  formControlName="appName"
                  class="l-textarea t-field--limitRad"
                  style="margin-left: 5px; border-radius: inherit"
                  placeholder="שם האפוטרופוס"
                />
              </div>
              <div
                class="login-form-row"
                style="
                  background-color: #e4eded;
                  margin: 5px;
                  border-radius: 0.75em;
                  height: fit-content;
                "
              >
                <input
                  formControlName="appRel"
                  class="l-textarea t-field--limitRad"
                  style="margin-left: 5px; border-radius: inherit"
                  placeholder="קשריו לנבדקת"
                />
              </div>
            </div>
            <div style="display: grid; place-self: center">
              <span>חתימת אפוטרופוס</span>
              <canvas
                id="canvasApp"
                #canvasApp
                [style.border]="'1px solid black'"
                [ngClass]="type == 'canvasApp' ? 'can-shadow' : ''"
                width="500"
                height="200"
                [ngClass]="{ 'disabled-canvas': lockedConsent }"
                (click)="setCanvas('canvasApp')"
              ></canvas>
              <button
                [disabled]="lockedConsent"
                style="position: relative; top: -2em; width: fit-content"
                (click)="clear('appSign')"
              >
                <ng-container>
                  <img
                    src="../../assets/icons/login/reset.png"
                    style="height: 1.5em; width: 1.5em"
                    matTooltip="Clear"
                  />
                </ng-container>
              </button>
            </div>
          </div>
          <div style="display: flex; margin-top: 2em">
            <div
              class="login-form-row"
              style="background-color: #e4eded; margin: 5px; border-radius: 0.75em; width: 30%"
            >
              <input
                formControlName="refferalDoc"
                class="l-textarea t-field--limitRad w100 h100"
                style="margin-left: 5px; border-radius: inherit"
                placeholder="שם משפחה"
              />
            </div>
            <div
              class="login-form-row"
              style="background-color: #e4eded; margin: 5px; border-radius: 0.75em; width: 70%"
            >
              <input
                formControlName="CreationTime"
                class="l-textarea t-field--limitRad w100 h100"
                style="margin-left: 5px; border-radius: inherit"
                placeholder="שם פרטי"
              />
            </div>
          </div>
          <div style="display: grid; place-self: center">
            <span>חתימת הרופא</span>
            <canvas
              id="canvasDoc"
              #canvasDoc
              [style.border]="'1px solid black'"
              [ngClass]="type == 'canvasDoc' ? 'can-shadow' : ''"
              width="500"
              height="200"
              [ngClass]="{ 'disabled-canvas': lockedConsent }"
              (click)="setCanvas('canvasDoc')"
            ></canvas>
            <button
              [disabled]="lockedConsent"
              style="position: relative; top: -2em; width: fit-content"
              (click)="clear('docSign')"
            >
              <ng-container>
                <img
                  src="../../assets/icons/login/reset.png"
                  style="height: 1.5em; width: 1.5em"
                  matTooltip="Clear"
                />
              </ng-container>
            </button>
          </div>
        </div>
        <div *ngIf="!lockedConsent" class="r-concent btn-row" class="r-concent btn-row">
          <button (click)="closed.emit('1')" class="orange-btn">בטל</button>
          <button [disabled]="toggleSave()" (click)="close(true)" class="blue-btn">
            שמור טופס חתום
          </button>
        </div>
      </div>

      <app-send-link
        *ngIf="showlink"
        (closed)="closeSendLinks($event)"
        [exam]="null"
        [isForm]="true"
        [gynConcent]="concentForm.value"
        (closeFromLinks)="closeFromLinks($event)"
      >
      </app-send-link>
    </div>
  </div>
</div>
